export default {
    name: 'InitializeFormMixin',
    watch: {
        initialValues(val) {
            this.$refs.form.finalForm.initialize(val);
        },
    },
};
